/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_displayInfo = {
    readonly pricing: {
        readonly showSold: boolean | null;
        readonly showUnavailable: boolean | null;
    } | null;
    readonly " $refType": "PdpRespSidebarBlurbs_displayInfo";
};
export type PdpRespSidebarBlurbs_displayInfo$data = PdpRespSidebarBlurbs_displayInfo;
export type PdpRespSidebarBlurbs_displayInfo$key = {
    readonly " $data"?: PdpRespSidebarBlurbs_displayInfo$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_displayInfo">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_displayInfo",
  "type": "ItemDisplayInfo",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pricing",
      "storageKey": null,
      "args": null,
      "concreteType": "PriceInfoDisplay",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showSold",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showUnavailable",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '2fdc3c9f176989c6082300b0d9cb6b4d';
export default node;
